<template>
	<component :is="tag" class="filter-bar-content-type__item" :class="{ active }">
		<slot />
	</component>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		tag?: string;
		active: boolean;
	}>(),
	{
		tag: 'div',
	}
);
</script>

<style lang="scss">
@import '~@/styles/rtl-support-mixins.scss';

.filter-bar-content-type__item {
	position: relative;
	margin-inline-end: 16px;

	&:last-of-type {
		margin-inline-end: 0;
	}

	&:after {
		content: '';
		max-width: 40px;
		width: 100%;
		display: block;
		border-bottom: 3px solid var(--jw-border-high-active);
		transform: scaleX(0);
		transition: transform 250ms ease-in-out;
		@include transform-origin-percentage(0, 50);
	}

	& > * {
		white-space: nowrap;
		font-size: 20px;
		font-weight: 900;
		color: var(--jw-text-low);
		transition: color 0.1s ease-in-out;
		transition-delay: 200ms;
		cursor: pointer;
	}

	&:not(.active) {
		& > *:hover {
			color: var(--jw-text-medium);
		}
	}

	&.active {
		&:after {
			transform: scaleX(1);
		}

		& > * {
			color: var(--jw-text-high) !important;
		}
	}
}
</style>
